import type { Field } from "../types/field";

//テキストの改行を配列に変換する
const dataWithLines = (fields: Field[]) => {
  const data = fields.map((field) => {
    const current_value = field.value as string;
    return {
      ...field,
      value: current_value.split("\n"),
    };
  });
  return data as Field[];
};

//オブジェクトごとのランダムなvalueの組み合わせを取得する
const getRandomCombination = (fields: Field[]) => {
  const randomValues = fields.map((field) => {
    const randomIndex = Math.floor(Math.random() * field.value.length);
    return field.value[randomIndex];
  });
  return fields.map((field, index) => {
    return {
      ...field,
      value: randomValues[index],
    };
  });
};

type Props = {
  fields: Field[];
  amount?: number;
};
export const createPrompt = ({ fields, amount }: Props) => {
  const current_amount = amount ? amount : 1;
  const data = dataWithLines(fields);
  let output = "";
  for (let index = 0; index < current_amount; index++) {
    const random_data = getRandomCombination(data);
    const result = random_data.map((item) => {
      const before_space = item.before.length > 0 ? " " : "";
      const after_space = item.after.length > 0 ? " " : "";
      const concat_text =
        item.value.length > 0 ? item.before + before_space + item.value + after_space + item.after : "";
      return concat_text;
    });
    const concat_result = result.join(" ");
    output = output.length > 0 ? output + "\n" + concat_result : concat_result;
  }
  return output;
};
